// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"service-fee_promotion_manager__27L5j","promotion_manager_title":"service-fee_promotion_manager_title__IlRpv","card":"service-fee_card__1VR7Q"};